export enum TipoUsuario {
  NOT = 0,
  ADM = 1,
  ADV = 2,
  ADA = 3,
  FPF = 4,
  FPJ = 5
}
